// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles (for desktops) */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Code font styling */
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Mobile-specific styles */
@media (max-width: 768px) {
  body {
    /* Adjust styles for mobile */
    font-size: 14px; /* Example: smaller font size for mobile */
    padding: 10px; /* Example: add padding for mobile */
  }

  /* You can add additional mobile-specific styles here */
  code {
    font-size: 12px; /* Example: smaller code font size for mobile */
  }
}

/* Tablet and larger devices */
@media (min-width: 769px) {
  body {
    /* Adjust styles for tablets and larger devices */
    font-size: 16px; /* Example: standard font size for desktop */
  }

  code {
    font-size: 14px; /* Example: standard code font size for desktop */
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE;aACW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,6BAA6B;IAC7B,eAAe,EAAE,0CAA0C;IAC3D,aAAa,EAAE,oCAAoC;EACrD;;EAEA,uDAAuD;EACvD;IACE,eAAe,EAAE,+CAA+C;EAClE;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,iDAAiD;IACjD,eAAe,EAAE,4CAA4C;EAC/D;;EAEA;IACE,eAAe,EAAE,iDAAiD;EACpE;AACF","sourcesContent":["/* Base styles (for desktops) */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Code font styling */\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Mobile-specific styles */\n@media (max-width: 768px) {\n  body {\n    /* Adjust styles for mobile */\n    font-size: 14px; /* Example: smaller font size for mobile */\n    padding: 10px; /* Example: add padding for mobile */\n  }\n\n  /* You can add additional mobile-specific styles here */\n  code {\n    font-size: 12px; /* Example: smaller code font size for mobile */\n  }\n}\n\n/* Tablet and larger devices */\n@media (min-width: 769px) {\n  body {\n    /* Adjust styles for tablets and larger devices */\n    font-size: 16px; /* Example: standard font size for desktop */\n  }\n\n  code {\n    font-size: 14px; /* Example: standard code font size for desktop */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
